import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { CVProvider } from "@/context/CVContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { AdminProvider } from "@/context/AdminContext";
import { AdminThemeProvider } from "@/context/AdminThemeContext";
import { GamificationProvider } from "@/context/GamificationContext";
import { initPostHog } from "@/lib/posthog";
import CVEntry from "@/pages/CVEntry";
import CVChat from "@/pages/CVChat";
import CVPreview from "@/pages/CVPreview";
import CVFeedback from "@/pages/CVFeedback";
import PersonalityTest from "@/pages/PersonalityTest";
import PersonalityResult from "@/pages/PersonalityResult";
import CompleteProfile from "@/pages/CompleteProfile";
import APIKeysPage from "@/pages/APIKeysPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminSessions from "@/pages/admin/AdminSessions";
import AdminErrors from "@/pages/admin/AdminErrors";
import AdminHealth from "@/pages/admin/AdminHealth";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminApiKeys from "@/pages/admin/AdminApiKeys";
import { Toaster } from "@/components/ui/sonner";
import { BadgeNotification, PointsAnimation } from "@/components/GamificationUI";
import ErrorBoundary from "@/components/ErrorBoundary";

// Initialize PostHog Analytics
initPostHog();

function App() {
  return (
    <ErrorBoundary>
    <LanguageProvider>
      <CVProvider>
        <GamificationProvider>
          <AdminProvider>
            <AdminThemeProvider>
              <div className="App">
                <BrowserRouter>
                  {/* Gamification overlays */}
                  <BadgeNotification />
                  <PointsAnimation />
                  
                  <Routes>
                    {/* Public routes */}
                    <Route path="/" element={<CVEntry />} />
                    <Route path="/go" element={<CVEntry />} />
                    <Route path="/chat" element={<CVChat />} />
                    <Route path="/preview" element={<CVPreview />} />
                    <Route path="/cv-feedback" element={<CVFeedback />} />
                    
                    {/* Personality Test routes */}
                    <Route path="/personality" element={<PersonalityTest />} />
                    <Route path="/personality-test" element={<PersonalityTest />} />
                    <Route path="/personality-result" element={<PersonalityResult />} />
                    
                    {/* Complete Profile (CV + Personality) */}
                  <Route path="/complete-profile" element={<CompleteProfile />} />
                  
                  {/* API Keys Page */}
                  <Route path="/api-keys" element={<APIKeysPage />} />
                  
                  {/* Admin routes */}
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/admin/users" element={<AdminUsers />} />
                  <Route path="/admin/sessions" element={<AdminSessions />} />
                  <Route path="/admin/errors" element={<AdminErrors />} />
                  <Route path="/admin/health" element={<AdminHealth />} />
                  <Route path="/admin/leads" element={<AdminLeads />} />
                  <Route path="/admin/api-keys" element={<AdminApiKeys />} />
                  
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </BrowserRouter>
              <Toaster position="top-right" />
            </div>
          </AdminThemeProvider>
        </AdminProvider>
      </GamificationProvider>
      </CVProvider>
    </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
